// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IGQX","type":"styles_type__zISCy","choices":"styles_choices__zYKaM"};